import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "assets/scss/dashboard.scss";
import "assets/css/charts_form_controls.css";
import "assets/css/grid_table.css";
import numeral from "numeral";
import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import moment from "moment";
import { getDataApi, saveApi, loadApi } from "services/appApi";
import { pecaPageRows, pecaRowsPerPageOptions } from "pages/common/envPECA";
import axios from "axios";

const MachinesPG = () => {
  let emptyRow = {
    machine_id: null,
    machine_name: "",
    machine_description: "",
    thereotical_capacity: 0,
    created_by: null,
    process_name: "",
    production_line_number: null,
    dxp_file_prefix: "",
    dxp_opc_comm_name: "",
    creation_date: "",
    last_updated_by: null,
    last_update_date: "",
    last_update_login: null,
    prod_enabled_flag: "Y",
    start_date: "",
    end_date: "",
    production_speed: 0,
    target_efficiency: 0,
    wait_time_sort_order: 0,
    prod_count_flag: "",
    machine_code: "",
    opc_machine_name: "",
    dxp_server_name: "",
    dxp_server_name_failover: ""
  };

  /**** 31-May-2024 Velmani P. Following changes are made to template
   * 	a. Use a generic name "row" instead of "product".  Following are the name changed from template
   * 	   a1. products ==> rows
   * 		[products, setProducts] ==> [products, setRows]
   * 		[deleteProductsDialog, setDeleteProductsDialog] ==> [deleteRowsDialog, setDeleteRowsDialog]
   * 		[selectedProducts, setSelectedProducts] ==> [selectedRows, setSelectedRows]
   * 	   a2. product  ==> row
   *		[productDialog, setProductDialog] ==> [productDialog, setRowDialog]
   *		[deleteProductDialog, setDeleteProductDialog] ==> [deleteRowDialog, setDeleteRowDialog]
   *		[product, setProduct] ==> [product, setRow]
   * ******/
  const [rows, setRows] = useState([]);
  const [rowDialog, setRowDialog] = useState(false);
  const [deleteRowDialog, setDeleteRowDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [globalFilter1, setGlobalFilter1] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoading1, setIsLoading1] = useState(false);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [expandedRowId, setExpandedRowId] = useState([]);
  const [machines, setMachines] = useState({});
  const toast = useRef(null);
  const dt = useRef(null);
  const dt1 = useRef(null);
  const fetchStarted = useRef(false);

  // Fetch Machines when the component mounts
    const fetchRows = async () => {
      try {
        setIsLoading(true);
        const response = await getDataApi("/api/setup/machines/selRows");
        console.log(response);
        console.log("Fetched machines:", response.data);
        console.log(response.data[0]);
        console.log(response.data[1]);
        if (response.data.length > 0) {
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            console.log("success=Y");
            setRows(response.data[1]);
            setIsLoading(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
            const errorInfo = response.data[2];

            // Set the error message and display the dialog
            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
        console.error("Error fetching machines:", error);
      }
      }
    };
  useLayoutEffect(() => {
     if(!fetchStarted.current){
    fetchStarted.current=true
    fetchRows();
     }
  }, []);
  const showProduct = (row) => {
    setRow({ ...row });
    setShowProductDialog(true);
  };
  const openNew = () => {
    setRow(emptyRow);
    setSubmitted(false);
    setRowDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setRowDialog(false);
    setShowProductDialog(false);
    setErrorDialogVisible(false);
  };
  const hideDeleteRowDialog = () => {
    setDeleteRowDialog(false);
  };

  const formatDateColumn = (dateValue) => {
    return dateValue ? moment.utc(dateValue).format("YYYY-MM-DD") : null;
  };

  const startDateBodyTemplate = (rowData) => {
    return formatDateColumn(rowData.start_date);
  };

  const endDateBodyTemplate = (rowData) => {
    return formatDateColumn(rowData.end_date);
  };

  /***
        const formatDateFields = (row, isNew) => {
            const formatDate = (date) => date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : null;
    
            return {
                ...row,
                creation_date: isNew ? formatDate(new Date()) : formatDate(row.creation_date),
                last_update_date: formatDate(new Date()),
                start_date: formatDate(row.start_date),
                end_date: formatDate(row.end_date)
            };
        };
         */

  const saveRow = async () => {
    setSubmitted(true);

    if (row.machine_name.trim()) {
      //      const isNew = !row.machine_id;
      //     const formattedRow = formatDateFields(row, isNew);

      let _rows = [...rows];
      let _row = { ...row };

      try {
        if (row.machine_id) {
          /*** Update Row */
          const response = await saveApi(row, "/api/setup/machines/updRow");
          //await axios.put(`http://localhost:5000/api/machines/${row.machine_id}`, formattedRow);
          //             const updatedRows = rows.map((p) => (p.machine_id === row.machine_id ? formattedRow : p));
          //             setRows(updatedRows);
          console.log("updating");
          console.log(response.data);
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            const index = findIndexById(row.machine_id);
            _rows[index] = _row;
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Machine Updated",
              life: 3000,
              width: "600px",
            });
          } else {
            let err_msg = response.data[1];
            toast.current.show({
              severity: "error",
              summary: err_msg,
              detail: "Machine Not Updated",
              life: 3000,
              width: "600px",
            });
          }
        } else {
          /*** Insert Row */
          const response = await saveApi(row, "/api/setup/machines/insRow");
          //const response = await axios.post('http://localhost:5000/api/machines', formattedRow);
          //       formattedRow.machine_id = response.data.id;
          //     setRows([...rows, formattedRow]);
          console.log("saving");
          console.log("Response data: ", response.data);
          console.log("Response: ", response);
          let successFlag =
            response.data[0]; /** This contains value of Y or N */
          if (successFlag === "Y") {
            _row.machine_id =
              response.data[1]; /** It contains newly created Id */
            _rows.push(_row);
            toast.current.show({
              severity: "success",
              summary: (
                <div style={{ marginright: "200px", width: "600px" }}>
                  Success
                </div>
              ),
              detail: <div style={{ width: "600px" }}>Machine Created</div>,
              life: 3000,
              width: "600px",
            });
          } else {
            let err_msg = response.data[2];
            toast.current.show({
              severity: "error",
              summary: <div style={{ width: "600px" }}>{err_msg}</div>,
              detail: <div style={{ width: "600px" }}>{err_msg}</div>,
              life: 3000,
              width: "600px",
            });
          }
        }

        setRows(_rows);
        setRowDialog(false);
        setRow(emptyRow);
      } catch (error) {
        console.error("Error saving machine:", error);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Machine Save Failed",
          life: 3000,
          width: "600px",
        });
      }
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Please fill in all required fields",
        life: 3000,
        width: "600px",
      });
    }
  };

  const editRow = (row) => {
    setRow({ ...row });
    setRowDialog(true);
  };

  const confirmDeleteRow = (row) => {
    setRow(row);
    setDeleteRowDialog(true);
  };

  const deleteRow = async () => {
    try {
      const response = await saveApi(row, "api/setup/machines/delRow");
      let successFlag = response.data[0];
      if (successFlag === "Y") {
        let _rows = rows.filter((val) => val.machine_id !== row.machine_id);
        setRows(_rows);
        setDeleteRowDialog(false);
        setRow(emptyRow);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Machine Deleted",
          life: 3000,
          width: "600px",
        });
      } else {
        let err_msg = response.data[1];
        toast.current.show({
          severity: "error",
          summary: err_msg,
          detail: "Machine Not Deleted",
          life: 3000,
          width: "600px",
        });
      }
    } catch (error) {
      console.error("Error deleting machine:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Machine Deletion Failed",
        life: 3000,
        width: "600px",
      });
    }
  };

  const findIndexById = (id) => {
    let index = -1;
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].machine_id === id) {
        index = i;
        break;
      }
    }
    return index;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const getLoadingHeaderContents = () => {
    return (
      <React.Fragment>
        <div className="row d-flex justify-content-center m-5">
          <div className="col-auto">
            <div className="card shadow-sm border-primary">
              <div className="card-header bg-primary text-white">
                <h2 className="mb-0">Setup Machines</h2>
              </div>
              <div className="card-body text-center">
                <h3>
                  <i className="fa-duotone fa-fw fa-spin-pulse fa-loader me-3"></i>{" "}
                  The page is loading...
                </h3>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  const getLoadedHeaderContents = () => {
                  return (
                    <React.Fragment>
                      <div className="header-container">
                        <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        Setup Machines
                        </h2>
                        <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                          <div className="header-container p-1">
                              <style>
                              {`
                                input::placeholder {
                                  font-size: 17px; 
                                }
                              `}
                            </style>
                          <span className="p-input-icon-right w-full md:w-auto"> 
                        <InputText
                          type="search"
                          onInput={(e) => setGlobalFilter(e.target.value)}
                          placeholder="Search..."
                          className="w-full lg:w-auto text-sm p-3"
                          style={{ fontSize: '17px' }} 
                        />
                      </span>
                          </div>
                        </h2>
                      </div>
                    </React.Fragment>
                  );
                }

  const deleteRowDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDeleteRowDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        className="p-button-text"
        onClick={deleteRow}
      />
    </React.Fragment>
  );

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _row = { ...row };
    _row[`${name}`] = val;

    setRow(_row);
  };

  /***
    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="New" icon="pi pi-plus" className="p-button-success p-mr-2" onClick={openNew} />
            </React.Fragment>
        )
    }

    const headerDontUse = (
        <div className="table-header">
            <h5 className="p-m-0">Manage Machines</h5>
            {/* <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </span> * /}
        </div>
    );
    */

  const header = (
    <div
      className="table-header"
      style={{
        display: "flex",
        justifyContent: "space-between",
        height: "3rem",
        alignContent: "center",
      }}
    >
      <div
        style={{
          width: window.innerWidth / 3,
          display: "flex",
          justifyContent: "flex-start",
          marginRight: "110px",
        }}
      >
        {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
      </div>
      <div>
        <Button
          // label="New"
          icon="pi pi-plus"
          className="p-button-success p-mr-2"
          // onClick={openNew}
          tooltip="New"
          tooltipOptions={{ position: "bottom" }}
          disabled={true}
        />
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
          style={{ marginLeft: "20px" }}
        />
      </div>
    </div>
  );

  const actionBodyEditTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-success p-mr-2"
          onClick={() => editRow(rowData)}
          tooltip="Edit"
          tooltipOptions={{ position: "bottom" }}
          // disabled={true}
        />
      </React.Fragment>
    );
  };

  const actionBodyDeleteTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-warning"
          //onClick={() => confirmDeleteRow(rowData)}
          tooltip="Delete"
          tooltipOptions={{ position: "bottom" }}
          disabled={true}
        />
      </React.Fragment>
    );
  };

  const fetchMachines = async (machine_id) => {
    setIsLoading1(true);
    const p_param = {
      p_machine_id: machine_id,
    };
    console.log(p_param);
    try {
      const response = await loadApi(
        p_param,
        "/api/setup/machineAddresses/selRows"
      );
      console.log("Fetched Address:", response.data);

      if (response.data.length > 0) {
        const successFlag = response.data[0];
        if (successFlag === "Y") {
          setMachines((prevMachines) => ({
            ...prevMachines,
            [machine_id]: response.data[1],
          }));
          setIsLoading1(false);
        } else {
          setMachines((prevMachines) => ({
            ...prevMachines,
            [machine_id]: [],
          }));
        }
      } else {
        setMachines((prevMachines) => ({ ...prevMachines, [machine_id]: [] }));
        setIsLoading1(false);
      }
    } catch (error) {
      console.error("Error fetching machines:", error);
    } finally {
      setIsLoading1(false);
    }
  };

  const fetchedIdsRef = useRef(new Set());

  useEffect(() => {
    expandedRowId.forEach((machine_id) => {
      if(!fetchedIdsRef.current.has(machine_id)) {
        fetchMachines(machine_id);
        fetchedIdsRef.current.add(machine_id);
      }
    });
  }, [expandedRowId])
 

  const drillDownTemplate = (rowData) => {
    const isExpanded = expandedRowId.includes(rowData.machine_id);

    return (
      <Button
        icon={isExpanded ? "pi pi-chevron-down" : "pi pi-chevron-right"}
        className={`p-button-rounded p-button-sm ${
          isExpanded ? "p-button-danger" : "p-button-primary"
        }`}
        onClick={() => toggleRowExpansion(rowData.machine_id)}
        tooltip="Detail"
        tooltipOptions={{ position: "bottom" }}
        style={{ fontSize: "1rem" }}
      />
    );
  };

  const toggleRowExpansion = (rowId) => {
    setExpandedRowId((prevExpandedRowId) =>
      prevExpandedRowId.includes(rowId)
        ? prevExpandedRowId.filter((id) => id !== rowId)
        : [...prevExpandedRowId, rowId]
    );
  };

  const rowExpansionTemplate = (data) => {
    const machineData = machines[data.machine_id] || [];
    const exportCSV1 = () => {
      dt1.current.exportCSV();
    };

    return (
      <div className="p-3">
        {isLoading1 && (<h6>The data is loading...</h6>)}
        {!isLoading1 && (<>
        <div className="header-container">
          <div className="header-container p-1">
            <style>
              {`
                input::placeholder {
                  font-size: 17px;
                }
              `}
            </style>
            <span className="p-input-icon-right w-full md:w-auto">
              <InputText
                type="search"
                onInput={(e) => setGlobalFilter1(e.target.value)}
                placeholder="Search..."
                className="w-full lg:w-auto text-sm p-3"
                style={{ fontSize: "17px" }}
              />
            </span>
            <Button
              icon="pi pi-upload"
              className="p-button-primary p-button-rounded"
              onClick={exportCSV1}
              tooltip="Export"
              tooltipOptions={{ position: "bottom" }}
              style={{ marginLeft: "20px", marginBottom: "10px" }}
            />
            <span style={{marginLeft: "20px"}}>
              <b>No. of Rows :</b> {machineData.length}
            </span>
          </div>
        </div>
        <DataTable
          ref={dt1}
          value={machineData}
          responsiveLayout="scroll"
          globalFilter={globalFilter1}
        >
          <Column field="machine_name" header="Machine Name" sortable></Column>
          <Column
            field="machine_address_code"
            header="Address Code"
            sortable
          ></Column>
          <Column
            field="machine_address_name"
            header="Address Name"
            sortable
          ></Column>
          <Column
            field="plc_hmi_mgmt_type_code"
            header="Data Mgmt"
            sortable
          ></Column>
          <Column
            field="address_type_code"
            header="Address Type"
            sortable
          ></Column>
          <Column
            field="address_value_type_code"
            header="Value Type"
            sortable
          ></Column>
          <Column field="opc_contents" header="OPC Contents" sortable></Column>
          <Column
            field="opc_external_ref"
            header="OPC Reference"
            sortable
          ></Column>
          <Column field="opc_model" header="OPC Model" sortable></Column>
          <Column
            field="is_machine_stop"
            header="Is MachStop"
            sortable
          ></Column>
          <Column
            field="machine_wait_time_sort_order"
            header="Sort Order"
            sortable
          ></Column>
          <Column field="active_flag" header="Active" sortable></Column>
        </DataTable>
        </>
        )}
      </div>
    );
  };
  const TCTemplate = (rowData) => {
    return numeral(rowData.thereotical_capacity).format("0,0");
  };
  const PLTemplate = (rowData) => {
    return numeral(rowData.production_line_number).format("0,0");
  };
  const PSTemplate = (rowData) => {
    return numeral(rowData.production_speed).format("0,0");
  };
  const TETemplate = (rowData) => {
    return numeral(rowData.target_efficiency).format("0,0");
  };
  const WTSOTemplate = (rowData) => {
    return numeral(rowData.wait_time_sort_order).format("0,0");
  };
  const TCNumber = row.thereotical_capacity ? numeral(row.thereotical_capacity).format("0,0") : null;
  const PLNumber = row.production_line_number ? numeral(row.production_line_number).format("0,0") : null;
  const PSNumber = row.production_speed ? numeral(row.production_speed).format("0,0") : null;
  const TENumber = row.target_efficiency ? numeral(row.target_efficiency).format("0,0") : null;
  const WTSONumber = row.wait_time_sort_order ? numeral(row.wait_time_sort_order).format("0,0") : null;
  const sDate = row.start_date ? moment.utc(row.start_date).format("YYYY-MM-DD") : null;
  const eDate = row.end_date ? moment.utc(row.end_date).format("YYYY-MM-DD") : null;

  // thereotical_capacity;
  // production_line_number;
  // production_speed;
  // target_efficiency;
  // wait_time_sort_order;
  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

     const CardComponent = ({title, data}) => {
          const rightAlignedLabels = ["Line# : ", "Theoretical Capacity : ", "Target Efficiency : ",
            "Production Speed : ", "Wait Time Sort Order : "
          ]
    
          return (
            <Card className="card-containers">
              <h5  style={{"fontWeight":"bold"}}> {title} </h5>
              <Divider className="my-2" />
              {data.map((item, index) => (
                <div key={index} className="label-value-pair">
                  <span className="label">{item.label}</span>
                  
                  {item.label &&
                  <span         
                  className={`value-box ${rightAlignedLabels.includes(item.label) ? "align-right": ""}`}>
                    {item.value}</span>
                  }
                  
                </div>
              ))}
            </Card>
          )
        }
  const inputBoxStyle = {
    backgroundColor:"rgb(235, 235, 235)",
    padding: "6px 10px",
    borderRadius: "4px",
    display: "block",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    flexGrow: 1,
    minWidth: 0,
  }
  const inputRightBoxStyle = {
    textAlign: "right",
    backgroundColor:"rgb(235, 235, 235)",
    padding: "6px 10px",
    borderRadius: "4px",
    display: "block",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    flexGrow: 1,
    minWidth: 0,
  }
  const inputDateStyle = {
    outline: "0.015625rem thin #d3d3d3",
    borderradius: "5px", 
    border: "thin solid #d3d3d3",
    paddingLeft: "6px",
    borderRadius: "4px",
    backgroundColor:"rgb(235, 235, 235)",
    width: "100%",
  }
  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`
  }
  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
        {isLoading ? getLoadingHeaderContents() : getLoadedHeaderContents()}
        {!isLoading && (
          <div className="card mb-3">
            {/* <div className="text-3xl text-800 font-bold mb-4">Setup Machines</div> */}
            <DataTable
              ref={dt}
              value={rows}
              selection={selectedRows}
              onSelectionChange={(e) => setSelectedRows(e.value)}
              dataKey="machine_id"
              scrollable
              scrollHeight="flex"
              className="custom-datatable-border"
              tableStyle={{ minWidth: "50rem" }}
              paginator
              rows={pecaPageRows}
              rowsPerPageOptions={pecaRowsPerPageOptions}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} machines"
              globalFilter={globalFilter}
              header={header}
              emptyMessage="No machines found"
              stripedRows
              showGridlines
              expandedRows={expandedRowId.map((machine_id) =>
                rows.find((rows) => rows.machine_id === machine_id)
              )}
              onRowToggle={(e) => {
                const rowId = e.data ? e.data.machine_id : null;
                setExpandedRowId((prev) =>
                  prev.includes(rowId)
                    ? prev.filter((machine_id) => machine_id !== rowId)
                    : [...prev, rowId]
                );
              }}
              rowExpansionTemplate={rowExpansionTemplate}
              responsiveLayout="scroll"
              rowExpansion
            >
              {/* <Column
                body={drillDownTemplate}
                style={{ width: "0.75rem", textAlign: "center" }}
              /> */}
              <Column
                body={readBodyTemplate}
                exportable={false}
                style={{ width: "0.75rem" }}
              ></Column>
              <Column
                body={drillDownTemplate}
                style={{ width: "3rem", textAlign: "center" }}
              />
              <Column
                field="machine_id"
                header="id"
                sortable="false"
                hidden="true"
                exportable={false}
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="machine_name"
                header="Machine Name"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="machine_description"
                header="Description"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="opc_machine_name"
                header="OPC Machine Name"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="opc_ip_address"
                header="Opc IP Address"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="dxp_opc_comm_name"
                header="DXP Comm Name"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="dxp_file_prefix"
                header="DXP File Prefix"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="production_line_number"
                header="Line#"
                sortable
                body={PLTemplate}
                style={{ whiteSpace: "nowrap", textAlign: "right" }}
              ></Column>
              <Column
                field="process_name"
                header="Process"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>

              <Column
                field="thereotical_capacity"
                header="Theoretical Capacity"
                sortable
                body={TCTemplate}
                style={{ whiteSpace: "nowrap", textAlign: "right" }}
              ></Column>

              <Column
                field="target_efficiency"
                header="Target Efficiency"
                sortable
                body={TETemplate}
                style={{ whiteSpace: "nowrap", textAlign: "right" }}
              ></Column>
              <Column
                field="production_speed"
                header="Production Speed"
                sortable
                body={PSTemplate}
                style={{ whiteSpace: "nowrap", textAlign: "right" }}
              ></Column>

              <Column
                field="wait_time_sort_order"
                header="Sort Order"
                sortable
                body={WTSOTemplate}
                style={{ whiteSpace: "nowrap", textAlign: "right" }}
              ></Column>
              <Column
                field="dxp_server_name"
                header="DXP Server Name"
                sortable
                style={{ whiteSpace: "nowrap"}}
              ></Column>
              <Column
                field="dxp_server_name_failover"
                header="Dxp Failover Server"
                sortable
                style={{ whiteSpace: "nowrap"}}
              ></Column>
              <Column
                field="prod_enabled_flag"
                header="Prod Enabled"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="start_date"
                header="Start Date Active"
                body={startDateBodyTemplate}
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="end_date"
                header="End Date Active"
                body={endDateBodyTemplate}
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                body={actionBodyEditTemplate}
                style={{ width: "0.75rem" }}
              ></Column>
              <Column
                body={actionBodyDeleteTemplate}
                style={{ width: "0.75rem" }}
              ></Column>
            </DataTable>
          </div>
        )}

        <Dialog
          visible={rowDialog}
          style={{ width: "1400px" }}
          modal
          className="p-fluid"
          onHide={hideDialog}
        >
          <h4 style={{"fontWeight":"bold"}}> Setup Machines </h4>
          <Divider className="my-4" />
          <h5 style={{"fontWeight":"bold"}}> Update Setup Machines </h5>
          <Divider className="my-4" />
          <div className="card-wrapper">
          <Card className="card-containers">
            <h5  style={{"fontWeight":"bold"}}> Machine Details </h5>
            <Divider className="my-2" />
            <div className="label-value-pair">
            <span className="label" htmlFor="machine_name">Machine Name : </span>
            <span style={{flexGrow:1}}>
            <InputText
              id="machine_name"
              value={row.machine_name}
              onChange={(e) => onInputChange(e, "machine_name")}
              required
              autoFocus
              className={classNames({
                "p-invalid": submitted && !row.machine_name,
              })}
              style={inputBoxStyle}
            />
            </span>
            {submitted && !row.machine_name && (
              <small className="p-error">Machine Name is required.</small>
            )}
          </div>
          <div className="label-value-pair">
            <span className="label" htmlFor="machine_description">Machine Description : </span>
            <span style={{flexGrow:1}}>
            <InputText
              id="machine_description"
              value={row.machine_description}
              onChange={(e) => onInputChange(e, "machine_description")}
              required
              style={inputBoxStyle}
            />
          </span>
          </div>
          </Card>
          <Card className="card-containers">
            <h5  style={{"fontWeight":"bold"}}> OPC/DXP Details </h5>
            <Divider className="my-2" />
            <div className="label-value-pair">
            <span className="label" htmlFor="opc_machine_name">OPC Machine Name : </span>
            <span style={{flexGrow:1}}>
            <InputText
              id="opc_machine_name"
              value={row.opc_machine_name}
              onChange={(e) => onInputChange(e, "opc_machine_name")}
              required
              autoFocus
              className={classNames({
                "p-invalid": submitted && !row.opc_machine_name,
              })}
              style={inputBoxStyle}
            />
            </span>
            {submitted && !row.opc_machine_name && (
              <small className="p-error">OPC Machine Name is required.</small>
            )}
          </div>
          <div className="label-value-pair">
            <span className="label"htmlFor="opc_ip_address">Opc IP Address : </span>
            <span style={{flexGrow:1}}>
            <InputText
              id="opc_ip_address"
              value={row.opc_ip_address}
              onChange={(e) => onInputChange(e, "opc_ip_address")}
              required
              autoFocus
              className={classNames({
                "p-invalid": submitted && !row.opc_ip_address,
              })}
              style={inputBoxStyle}
            />
            </span>
            {submitted && !row.opc_ip_address && (
              <small className="p-error">Opc IP Address is required.</small>
            )}
          </div>
          <div className="label-value-pair">
            <span className="label" htmlFor="dxp_opc_comm_name">DXP Comm Name : </span>
            <span style={{flexGrow:1}}>
            <InputText
              id="dxp_opc_comm_name"
              value={row.dxp_opc_comm_name}
              onChange={(e) => onInputChange(e, "dxp_opc_comm_name")}
              required
              autoFocus
              className={classNames({
                "p-invalid": submitted && !row.dxp_opc_comm_name,
              })}
              style={inputBoxStyle}
            />
            </span>
            {submitted && !row.dxp_opc_comm_name && (
              <small className="p-error">DXP Comm Name is required.</small>
            )}
          </div>
          <div className="label-value-pair">
            <span className="label" htmlFor="dxp_file_prefix">DXP File Prefix : </span>
            <span style={{flexGrow:1}}>
            <InputText
              id="dxp_file_prefix"
              value={row.dxp_file_prefix}
              onChange={(e) => onInputChange(e, "dxp_file_prefix")}
              required
              autoFocus
              className={classNames({
                "p-invalid": submitted && !row.dxp_file_prefix,
              })}
              style={inputBoxStyle}
            />
            </span>
            {submitted && !row.dxp_file_prefix && (
              <small className="p-error">DXP File Prefix is required.</small>
            )}
          </div>
          <div className="label-value-pair">
            <span className="label" htmlFor="dxp_server_name">DXP Server Name : </span>
            <span style={{flexGrow:1}}>
            <InputText
              id="dxp_server_name"
              value={row.dxp_server_name}
              onChange={(e) => onInputChange(e, "dxp_server_name")}
              required
              autoFocus
              className={classNames({
                "p-invalid": submitted && !row.dxp_server_name,
              })}
              style={inputBoxStyle}
            />
            </span>
            {submitted && !row.dxp_server_name && (
              <small className="p-error">DXP Server Name is required.</small>
            )}
          </div>
          <div className="label-value-pair">
            <span className="label" htmlFor="dxp_server_name_failover">Dxp Failover Server : </span>
            <span style={{flexGrow:1}}>
            <InputText
              id="dxp_server_name_failover"
              value={row.dxp_server_name_failover}
              onChange={(e) => onInputChange(e, "dxp_server_name_failover")}
              required
              autoFocus
              className={classNames({
                "p-invalid": submitted && !row.dxp_server_name_failover ,
              })}
              style={inputBoxStyle}
            />
            </span>
            {submitted && !row.dxp_server_name_failover && (
              <small className="p-error">Dxp Failover Server is required.</small>
            )}
          </div>
          </Card>
          <Card className="card-containers">
            <h5  style={{"fontWeight":"bold"}}> Production/Process Details </h5>
            <Divider className="my-2" />
            <div className="label-value-pair" style={{flexWrap: "nowrap"}}>
            <span className="label" htmlFor="production_line_number">Line# : </span>
            <span style={{flexGrow:1}}>
            <InputNumber
              id="production_line_number"
              value={PLNumber}
              onChange={(e) => onInputChange(e, "production_line_number")}
              required
              autoFocus
              className={classNames({
                "p-invalid": submitted && !PLNumber,
              })}
              inputStyle={inputRightBoxStyle}
            />
            </span>
            {submitted && !PLNumber && (
              <small className="p-error">Production Line Number is required.</small>
            )}
          </div>
          <div className="label-value-pair">
            <span className="label" htmlFor="process_name">Process Name : </span>
            <span style={{flexGrow:1}}>
            <InputText
              id="process_name"
              value={row.process_name}
              onChange={(e) => onInputChange(e, "process_name")}
              required
              autoFocus
              className={classNames({
                "p-invalid": submitted && !row.process_name,
              })}
              style={inputBoxStyle}
            />
            </span>
            {submitted && !row.process_name && (
              <small className="p-error">Process Name is required.</small>
            )}
          </div>
          </Card>
          <Card className="card-containers">
            <h5  style={{"fontWeight":"bold"}}> Other Details </h5>
            <Divider className="my-2" />
            <div className="label-value-pair">
            <span className="label" htmlFor="thereotical_capacity">Theoretical Capacity : </span>
            <span style={{flexGrow:1}}>
            <InputNumber
              id="thereotical_capacity"
              value={TCNumber}
              onValueChange={(e) => onInputChange(e, "thereotical_capacity")}
              className={classNames({
                "p-invalid": submitted && !TCNumber,
              })}
              // mode="decimal"
              // minFractionDigits={2}
              inputStyle={inputRightBoxStyle}
            />
            </span>
          </div>
          <div className="label-value-pair">
            <span className="label" htmlFor="target_efficiency">Target Efficiency : </span>
            <span style={{flexGrow:1}}>
            <InputNumber
              id="target_efficiency"
              value={TENumber}
              onValueChange={(e) => onInputChange(e, "target_efficiency")}
              className={classNames({
                "p-invalid": submitted && !TENumber,
              })}
              // mode="decimal"
              // minFractionDigits={2}
              inputStyle={inputRightBoxStyle}
            />
            </span>
          </div>
          <div className="label-value-pair">
          <span className="label" htmlFor="production_speed">Production Speed : </span>
          <span style={{flexGrow:1}}>
            <InputNumber
              id="production_speed"
              value={PSNumber}
              onValueChange={(e) => onInputChange(e, "production_speed")}
              className={classNames({
                "p-invalid": submitted && !PSNumber,
              })}
              // mode="decimal"
              // minFractionDigits={2}
              inputStyle={inputRightBoxStyle}
            />
          </span>
          </div>
          <div className="label-value-pair">
          <span className="label" htmlFor="wait_time_sort_order">Wait Time Sort Order : </span>
          <span style={{flexGrow:1}}>
            <InputNumber
              id="wait_time_sort_order"
              value={WTSONumber}
              onValueChange={(e) => onInputChange(e, "wait_time_sort_order")}
              className={classNames({
                "p-invalid": submitted && !WTSONumber,
              })}
              inputStyle={inputRightBoxStyle}
            />
          </span>
          </div>
          <div className="label-value-pair">
          <span className="label" htmlFor="prod_enabled_flag">Prod Enabled : </span>
          <span style={{flexGrow:1}}>
            <InputText
              id="prod_enabled_flag"
              value={row.prod_enabled_flag}
              onValueChange={(e) => onInputChange(e, "prod_enabled_flag")}
              style={inputBoxStyle}
            />
          </span>
          </div>
          {/* <div className="p-field-checkbox">
            <Checkbox
              inputId="prod_enabled_flag"
              value={row.prod_enabled_flag}
              onChange={(e) => onInputChange(e, "prod_enabled_flag")}
              checked={row.prod_enabled_flag === "Y"}
            />
            <span className="label" htmlFor="prod_enabled_flag"> Prod Enabled</span>
          </div> */}
          </Card>
          <Card className="card-containers">
            <h5  style={{"fontWeight":"bold"}}> Start/End Date Details </h5>
            <Divider className="my-2" />
            <div className="label-value-pair">
            <span className="label" htmlFor="start_date">Start date : </span>
            <span style={{flexGrow:1}} className="input-wrapper">
            <input
            type="datetime-local"
              id="start_date"
              defaultValue={formatDateTime(row.start_date)}
              onChange={(e) => onInputChange(e, "start_date")}
              style={inputDateStyle}
            />
            </span>
          </div>
          <div className="label-value-pair">
            <span className="label" htmlFor="end_date">End date : </span>
            <span style={{flexGrow:1}} className="input-wrapper">
            <input
              type="datetime-local"
              id="end_date"
              defaultValue={formatDateTime(row.end_date)}
              onChange={(e) => onInputChange(e, "end_date")}
              style={inputDateStyle}
            />
            </span>
          </div>
          </Card>
          </div>
          <div className="btn-container">
          <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-text"
            onClick={hideDialog}
            style={{"width":"20%","backgroundColor":"#0d6efd", "color":"white", "borderRadius":"4px", "cursor":"pointer"}}
          />
          <Button
            label="Save"
            icon="pi pi-check"
            className="p-button-text"
            onClick={saveRow}
            style={{"width":"20%","backgroundColor":"#0d6efd", "color":"white", "borderRadius":"4px", "cursor":"pointer"}}
          />
          </div>
        </Dialog>

        {/* <Dialog
          visible={deleteRowDialog}
          style={{ width: "450px" }}
          header="Confirm"
          modal
          footer={deleteRowDialogFooter}
          onHide={hideDeleteRowDialog}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle p-mr-3"
              style={{ fontSize: "2rem" }}
            />
            {row && (
              <span>
                Are you sure you want to delete <b>{row.machine_name}</b>?
              </span>
            )}
          </div>
        </Dialog> */}

       <Dialog visible={showproductDialog} style={{ width: '1400px' }} modal className="p-fluid" onHide={hideDialog}>     
                        <h4 style={{"fontWeight":"bold"}}> Setup Machines </h4>
                        <Divider className="my-4" />
                        <h5 style={{"fontWeight":"bold"}}> View Setup Machines </h5>
                        <Divider className="my-4" />
                        <div className="card-wrapper">
                          <CardComponent
                            title="Machine Details"
                            data={[
                              {label:"Machine Name : ", value: row.machine_name },
                              {label:"Machine Description : ", value: row.machine_description },
                            ]}
                          />
                          <CardComponent
                            title="OPC/DXP Details"
                            data={[
                              {label:"OPC Machine Name : ", value: row.opc_machine_name },
                              {label:"OPC IP Address : ", value: row.opc_ip_address },
                              {label:"DXP Comm Name : ", value: row.dxp_opc_comm_name },
                              {label:"DXP File Prefix : ", value: row.dxp_file_prefix },
                              {label:"DXP Server Name : ", value: row.dxp_server_name },
                              {label:"Dxp Failover Server : ", value: row.dxp_server_name_failover  },
                            ]}
                          />
                          <CardComponent
                            title="Production/Process Details"
                            data={[
                              {label:"Line# : ", value: PLNumber },
                              {label:"Process Name : ", value: row.process_name },
                            ]}
                          />
                         <CardComponent
                            title="Other Details"
                            data={[
                              {label:"Theoretical Capacity : ", value: TCNumber },
                              {label:"Target Efficiency : ", value: TENumber },
                              {label:"Production Speed : ", value: PSNumber },
                              {label:"Wait Time Sort Order : ", value: WTSONumber },
                              {label:"Prod Enabled : ", value: row.prod_enabled_flag },
                            ]}
                          />
                          <CardComponent
                            title="Start/End Date Details"
                            data={[
                              {label:"Start Date : ", value: sDate },
                              {label:"End Date : ", value: eDate },
                            ]}
                          />
                         </div>
                    </Dialog>
                    <Dialog 
                        header="API Error" 
                        visible={errorDialogVisible} 
                        style={{ width: '400px' }} 
                        onHide={hideDialog} 
                        footer={
                            <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                        }
                    >    
                     <p>
        
                            {errorMessage}
                        </p>
                    </Dialog>
                    <style jsx>{`
                      .card-wrapper {
                        display: grid;
                        grid-template-columns: repeat(3,1fr);
                        gap: 10px;
                        padding: 5px;
                      }
        
                      .card-containers {
                        display: flex;
                        background-color: #f9f9f9;
                        flex-direction: column;
                        justify-content: flex-start;
                        border: 1px solid #ccc;
                        paddig: 10px;
                        box-shadow: 4px 4px 10px rgba(0,0,0,0.2);
                        height: auto;
                        width: 100%;
                      }
        
                      .label-value-pair {
                        display: flex;
                        flex-direction: row,
                        align-items: flex-start;
                        gap: 5px;
                        margin-bottom: 8px;
                        flex-wrap: wrap;
                      }
        
                      .label {
                        font-weight: bold;
                        white-space: nowrap;
                      }
        
                      .value-box {
                        background-color:rgb(235, 235, 235);
                        padding: 6px 10px;
                        border-radius: 4px;
                        display: block;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        flex-grow: 1;
                        min-width: 0;
                      }

                      .align-right {
                        text-align: right;
                        background-color:rgb(235, 235, 235);
                        padding: 6px 10px;
                        border-radius: 4px;
                        display: block;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        flex-grow: 1;
                        min-width: 0;
                      }

                      .btn-container {
                      display: flex;
                      justify-content: center;
                      gap:20px;
                      margin-top:20px;
                      }
                    `}
                    </style>
                    </div>
    </div>
  );
};

export default MachinesPG;
